export default __webpack_public_path__ + "static/front_img_1-81f629477d05bb5ce9701c28b9280024.png";